import { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { app } from "@microsoft/teams-js";
import { AppContext } from '../../AppContext';
import { logoutAllTabs } from '../../Wallboards/Wallboards/Wallboards';

const Layout = (props : any) => {
	const [currentTheme, setCurrentTheme] = useState<string>('light');
	const [currentLanguage, setCurrentLanguage] = useState<string>('en');

	app.getContext().then((context) => {
		if(Object.keys(context).length !== 0) {
			setCurrentLanguage(context.app.locale)

			if(context.app.theme === 'dark') {
				setCurrentTheme("dark");
				document.body.classList.remove('light-theme')
				document.body.classList.add('dark-theme')
			}
		}
	});

	if(window.matchMedia("(prefers-color-scheme: dark)").matches && currentTheme === 'dark') {
		document.body.classList.remove('light-theme')
		document.body.classList.add('dark-theme')
	}

	useEffect(() => {
		logoutAllTabs();
	}, [])

	const themeType = currentTheme === 'dark' ? 'dark' : 'light';

	return <AppContext.Provider
		value={{
			themeType: themeType,
			language: currentLanguage
		}}
	>
		<ToastContainer
			limit={1}
			theme={themeType}
			pauseOnHover={false}
			pauseOnFocusLoss={false}
		/>
		{props.children}
	</AppContext.Provider>
}

export default Layout;
